import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { HubProvider } from '../lib/api/domains/technicianHub';

export type { HubProvider };

export const ACTIVE_HUB_QUERY_KEY = ['hubProvider'] as const;

export function useActiveHub() {
  const query = useQuery({
    queryKey: ACTIVE_HUB_QUERY_KEY,
    queryFn: () => api.getHubProvider(),
    staleTime: 60_000,
  });

  return {
    provider: query.data?.provider,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
